/**
 * "MIS PROVEEDORES": los médicos que la agencia ya registró en alguna ficha, para
 * elegirlos en otra sin volver a escribirlos (Fabiola Montano, 2026-10-14, E-405).
 *
 * Sale solo el proveedor (nombre, especialidad, NPI, centro, dirección, teléfono,
 * red), nunca de qué cliente es: lo arma el servidor en
 * deskte-api/src/utils/directorioDeProveedores.ts. Se busca mientras se escribe
 * porque la lista es de la propia agencia, no de un servicio de fuera.
 */
import { useEffect, useState } from 'react';
import { getDoctorsDirectory } from '../api.js';

export default function MisProveedores({ onElegir, lang = 'es' }) {
  const es = lang !== 'en';
  const [q, setQ] = useState('');
  const [lista, setLista] = useState(null); // null = cargando
  const [error, setError] = useState('');

  useEffect(() => {
    let vivo = true;
    const t = setTimeout(() => {
      getDoctorsDirectory(q.trim())
        .then((r) => { if (vivo) { setLista(r); setError(''); } })
        .catch((e) => { if (vivo) { setLista([]); setError(e.message || String(e)); } });
    }, q ? 300 : 0);
    return () => { vivo = false; clearTimeout(t); };
  }, [q]);

  const direccion = (p) => [p.direccion, p.ciudad, [p.estado, p.zip].filter(Boolean).join(' ')].filter(Boolean).join(', ');

  return (
    <div>
      <input className="dkt-inp" style={{ width: '100%', fontSize: '.8rem', padding: '.45rem .6rem', boxSizing: 'border-box' }}
        value={q} onChange={(e) => setQ(e.target.value)} autoFocus
        placeholder={es ? 'Buscar por nombre, especialidad, centro, NPI o ciudad…' : 'Search by name, specialty, center, NPI or city…'} />
      {!!error && <div style={{ fontSize: '.7rem', color: 'var(--c-amber,#ffb700)', marginTop: 4 }}>{es ? 'No se pudo cargar la lista: ' : 'Could not load the list: '}{error}</div>}
      <div style={{ marginTop: '.4rem', maxHeight: 260, overflowY: 'auto', border: '1px solid var(--c-border,#1a3550)', borderRadius: 8 }}>
        {lista === null && (
          <div style={{ padding: '.55rem .7rem', fontSize: '.74rem', color: 'var(--c-text3,#45688a)' }}>{es ? 'Cargando…' : 'Loading…'}</div>
        )}
        {Array.isArray(lista) && !lista.length && !error && (
          <div style={{ padding: '.55rem .7rem', fontSize: '.74rem', color: 'var(--c-text3,#45688a)' }}>
            {q
              ? (es ? 'Ninguno de tus proveedores coincide. Búscalo en el directorio del Mercado o escríbelo en "Nuevo".' : 'None of your providers match. Search the Marketplace directory or type it in "New".')
              : (es ? 'Todavía no hay proveedores guardados en las fichas. El primero que guardes aparecerá aquí para los demás clientes.' : 'No providers saved on any client yet. The first one you save will show up here for other clients.')}
          </div>
        )}
        {(lista || []).map((p) => (
          <button key={p.clave} type="button" onClick={() => onElegir(p)}
            style={{ display: 'block', width: '100%', textAlign: 'left', padding: '.45rem .7rem', border: 'none', borderBottom: '1px solid rgba(26,53,80,.45)',
              background: 'transparent', cursor: 'pointer', fontFamily: 'inherit' }}>
            <div style={{ fontSize: '.8rem', fontWeight: 700, color: 'var(--c-white,#eef6ff)' }}>
              🩺 {p.nombre}
              {p.usos > 1 && <span style={{ fontWeight: 500, color: 'var(--c-text3,#45688a)', fontSize: '.68rem' }}> · {es ? `en ${p.usos} fichas` : `on ${p.usos} clients`}</span>}
            </div>
            <div style={{ fontSize: '.68rem', color: 'var(--c-text2,#7aa3c0)' }}>
              {[p.especialidad, p.centro, p.npi && `NPI ${p.npi}`].filter(Boolean).join(' · ')}
            </div>
            <div style={{ fontSize: '.68rem', color: 'var(--c-text3,#45688a)' }}>
              {[direccion(p), p.telefono].filter(Boolean).join(' · ')}
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
